import React from 'react';
import { useMutation } from 'react-query';
import { useServiceClient } from 'common';
import { SharedEndPoints, SharedReactQueryKey } from './query-enum';
import { IAnnouncementPayload } from 'modules/shared/queries';

export const useCreateAnnouncementQuery = () => {
    const { postData } = useServiceClient();
    const saveAnnouncement = React.useCallback((args: IAnnouncementPayload) => postData(SharedEndPoints.SAVE_ANNOUNCEMENT, args).then((res) => res.json()), [postData]);
    return useMutation(SharedReactQueryKey.SAVE_ANNOUNCEMENT, saveAnnouncement);
};
